const ROUTE_BUILDING_STRATEGY = {
  Shortest: 1,
  Fastest: 2
};
Object.freeze(ROUTE_BUILDING_STRATEGY);

export default ROUTE_BUILDING_STRATEGY;